import { ErrorOutline } from '@mui/icons-material'
import { TAppealService } from 'feature/appeals/type'
import { convertDataToStringWithMonth } from 'helpers/date/convertDataToStringWithMonth'
import { isMoscowTimeZone } from 'helpers/date/isMoscowTimeZone'
import { ReactNode } from 'react'
import { DesktopMobileTooltip } from 'widget/DesktopMobileTooltip/DesktopMobileTooltip'
import { InformationBlock } from 'widget/InformationBlock/InformationBlock'

import style from './OrderService.module.scss'

type TOrderService = {
  service: TAppealService
  timeSlotText: string
  children: ReactNode
}

// информация о ремонте/монтаже заявки

export function OrderService({
  service,
  timeSlotText,
  children,
}: TOrderService) {
  const { grade } = service
  return (
    <section className={style.orderService}>
      <div className={style.visitDate}>
        <InformationBlock title={timeSlotText}>
          <span className={style.timeSlot}>
            {convertDataToStringWithMonth(service.date)}
            {!isMoscowTimeZone() && (
              <DesktopMobileTooltip
                title='По местному времени'
                Icon={<ErrorOutline />}
              />
            )}
          </span>
        </InformationBlock>
      </div>
      {grade !== null && <>{children}</>}
    </section>
  )
}
